import isMac from '@/utils/isMac'

/**
 * This takes an event object, and returns true if event belong to ctrl key (in non-mac) or cmd key (in mac)
 * @param event
 * @returns {boolean}
 */
export const isCtrlEvent = event => (isMac ? event.metaKey : event.ctrlKey)
export const isShiftEvent = event => event.shiftKey
export const isCtrlOrShiftEvent = event => isCtrlEvent(event) || isShiftEvent(event)
